import type { FormCompositionHook } from '@ipfabric/ui-components/utils/formSnippets/useFormComposition';

type Props = {
  formComposition: FormCompositionHook<'privilegedCredentials'>;
};

export const PrivilegedCredentialsSubTab = ({ formComposition }: Props) => {
  return (
    <div className='flex flex-col flex-1 gap'>
      {formComposition.renderGroup('privilegedCredentials')}
    </div>
  );
};
